// Enable tabbable tabs via JS

$(function () {
  $('body').on('click', '.TabPanel .nav-tabs a', function (e) {
    e.preventDefault();
    const tabLink = $(this);
    const tabIndex = tabLink.parent().index();
    const tabPanel = $(this).closest('.TabPanel');
    const tabPane = tabPanel.find('.tab-pane').eq(tabIndex);

    tabPanel.find('.active').removeClass('active show');
    tabLink.addClass('active');
    tabPane.addClass('active show');
  });

  $('.js-example-basic-single').select2({
    multiple: true
  });

  $('[data-delayed-scrollto]').click(function(e){
    let target = $(this).data('delayed-scrollto');
    setTimeout(function(){
      $("html, body").animate({
        scrollTop: $(target).offset().top
      }, 500);
    }, 600);
  });

/*  $('#facilitiesList').on('shown.bs.tab hidden.bs.tab', function (e) {
      $('.facilitiesFilterItem').toggleClass('invisible');
    })*/
});
